import React from "react";
import { MDBBtn } from "mdbreact";
import { Link } from "gatsby";
import "./cardPhotoText.css";

const LOGO_FAIXA =
	"https://www.feevale.br/s/conteudo/0513b825-4ecf-4c36-a425-acf325d7141b/logo_faixa.svg";

const REPETICOES_FAIXA = 10;

const FaixaGrupo = () => (
	<div className="cPhoTexFaixaGrupo" aria-hidden="true">
		{Array.from({ length: REPETICOES_FAIXA }).map((_, index) => (
			<div className="cPhoTexFaixaItem" key={index}>
				<span>VESTIBULAR 2027</span>
				<img src={LOGO_FAIXA} alt="" />
			</div>
		))}
	</div>
);

const FaixaAnimada = ({ posicao }) => (
	<div
		className={`cPhoTexFaixa cPhoTexFaixa--${posicao}`}
		aria-hidden="true"
	>
		<div className="cPhoTexFaixaTrack">
			<FaixaGrupo />
			<FaixaGrupo />
		</div>
	</div>
);

export default function App({
	Nome,
	Texto,
	LinkImage,
	White,
	NomeFoto = "",
	CursoFoto = "",
}) {
	return (
		<div className="cPhoTexCard" style={{ width: "100%", height: "100%" }}>
			<FaixaAnimada posicao="top" />
			<FaixaAnimada posicao="right" />
			<FaixaAnimada posicao="bottom" />
			<FaixaAnimada posicao="left" />

			<div className="cPhoTexCardInner">
				<div className="cPhoTexImageWrap">
					<img className="cPhoTexImage" src={LinkImage} alt={Nome} />

					{(NomeFoto || CursoFoto) && (
						<div className="cPhoTexImageOverlay">
							{NomeFoto && (
								<strong className="cPhoTexImageOverlayNome">
									{NomeFoto}
								</strong>
							)}

							{CursoFoto && (
								<span className="cPhoTexImageOverlayCurso">
									{CursoFoto}
								</span>
							)}
						</div>
					)}
				</div>

				<div
					className={`${
						White ? "cPhoTexBodyTextWhite" : "cPhoTexBodyText"
					} text-center`}
				>
					<h5 className="cPhoTexTitle">{Nome}</h5>
					<div>{Texto}</div>

					<Link
						className="cPhoTexButtonLink"
						to={`/cursos?modalidade=${Nome.split(" ")[1]}`}
					>
						<MDBBtn className="cPhoTexButton cPhoTexButton--roxo">
							Conheça nossos cursos
						</MDBBtn>
					</Link>
				</div>
			</div>
		</div>
	);
}
